import { render, staticRenderFns } from "./default.vue?vue&type=template&id=06d8fdc4"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=06d8fdc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ClockChangeBanner: require('/app/components/ClockChangeBanner.vue').default,CommercialOperationBanner: require('/app/components/CommercialOperationBanner.vue').default,HeaderPromotionalBanner: require('/app/components/HeaderPromotionalBanner.vue').default,OrganizationStructuredData: require('/app/components/OrganizationStructuredData.vue').default,ModalProductAddedToCart: require('/app/components/ModalProductAddedToCart.vue').default,LedSearchForm: require('/app/components/LedSearchForm.vue').default,SearchOverlay: require('/app/components/SearchOverlay.vue').default,ScrollTop: require('/app/components/ScrollTop.vue').default,CountriesLanguagesSidebar: require('/app/components/CountriesLanguagesSidebar.vue').default,VehiclesSelectorSidebar: require('/app/components/VehiclesSelectorSidebar.vue').default,ProductsSidebar: require('/app/components/ProductsSidebar.vue').default,GoogleStoreWidget: require('/app/components/GoogleStoreWidget.vue').default,ModalSubscriptionNewsletter: require('/app/components/ModalSubscriptionNewsletter.vue').default})
